import { Airline } from "../../my-type";
import { ActionType } from "../action-types";
import { Action } from "../actions";
//import { User } from "../../my-type";


const airlineReducer = (state: Airline[] = [], action: Action) => {
  switch (action.type) {
    case ActionType.UPDATE_AIRLINE:
      return (state = action.payload);
    default:
      return state;
  }
}

export default airlineReducer;